import React from 'react';
import EditOrderForm from './EditOrderForm';

class EditOrderPage extends React.Component {
  render() {
    return (
      <div>
        <EditOrderForm orderId={this.props.location.query.id}/>
      </div>
    );
  }
}

export default EditOrderPage;



// WEBPACK FOOTER //
// ./src/components/order/EditOrderPage.js